function init() {
    const sectionIndustries = document.querySelector("section.industries-menu");

    if (sectionIndustries) {
        const dropdownList = sectionIndustries.querySelector(".dropdown-list");
        const subNav = sectionIndustries.querySelectorAll(".sub-nav");
        const itemNav = document.querySelectorAll(".dropdown-list > ul > li");

        dropdownList.style.minHeight = `${dropdownList.offsetHeight}px`;

        if (itemNav.length > 0) {
            let activeIndex = 0;
            itemNav[activeIndex].classList.add("active");
            dropdownList.style.height = `${subNav[activeIndex].offsetHeight}px`;

            for (let i = 0; i < itemNav.length; i++) {
                itemNav[i].addEventListener("click", function() {
                    if (activeIndex === i) {
                        itemNav[i].classList.remove("active");
                        activeIndex = null;

                        if (sectionIndustries.offsetWidth >= 1440) {
                            dropdownList.style.height = `0px`;
                        } else {
                            dropdownList.style.height = "min-content";
                        }

                        return;
                    }

                    if (activeIndex !== null) {
                        itemNav[activeIndex].classList.remove("active");
                    }

                    itemNav[i].classList.add("active");
                    activeIndex = i;

                    // Ajustar altura según breakpoints
                    if (sectionIndustries.offsetWidth >= 1440) {
                        dropdownList.style.height = `${subNav[i].offsetHeight}px`;
                    }
                });
            }

            // REDIMENSIONAR
            window.addEventListener("resize", () => {
                if (sectionIndustries.offsetWidth >= 1440) {
                    if (activeIndex !== null) {
                        dropdownList.style.height = `${subNav[activeIndex].offsetHeight}px`;
                    } else {
                        dropdownList.style.height = `0px`;
                    }
                } else {
                    dropdownList.style.height = "min-content";
                }
            });
        }
    }
}

export default { init };
